import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';

const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>(({ href, ...props }, ref) => <RouterLink ref={ref} to={href} {...props} />);

const ButtonLink: React.FC<ButtonProps> = ({ children, href, ...props }) => (
  <Button href={href} LinkComponent={LinkBehavior} {...props}>
    {children}
  </Button>
);

export default ButtonLink;
